"use strict";
exports.__esModule = true;
var core_1 = require("@ngx-translate/core");
var SharedModule = /** @class */ (function () {
    function SharedModule(translate) {
        this.translate = translate;
    }
    return SharedModule;
}());
exports.SharedModule = SharedModule;
